import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Button, Form, Image, List, Space, Spin, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { clearUsersList, getUserById, getUsersForJobAssigning, getUsersList, updateUser } from '../../store/slices/userSlice';
import { Alert, Card, Descriptions, Select } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, FieldTimeOutlined, FileTextOutlined, MailOutlined, PhoneOutlined, ProductFilled, ProductOutlined, ScheduleOutlined, UserOutlined } from '@ant-design/icons';
import { useForm } from 'antd/es/form/Form';
import { createJob, formattedDateTime, getJobById, updateJobStatus, updateJobStep } from '../../store/slices/jobSlice.js';

const ViewJob = () => {
    const { id } = useParams();
    const [form] = useForm();
    const [statusForm] = useForm();
    const [jobStepform] = useForm();
    const navigate = useNavigate();
    const [buttonLoading, setButtonLoading] = useState(false);
    const [statusButtonLoading, setStatusButtonLoading] = useState(false);
    const [jobStepBtnLoading, setjobStepBtnLoading] = useState(false);
    const [address, setAddress] = useState("")
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [statusAlertMessage, setStatusAlertMessage] = useState("");
    const [statusalertType, setStatusAlertType] = useState("success");
    const [jobStepAlertMessage, setJobStepAlertMessage] = useState("");
    const [jobAlertType, setJobAlertType] = useState("success");
    const [totalPrice, setTotalPrice] = useState(0)
    const dispatch = useDispatch();
    const job = useSelector((state) => state?.jobs)
    const jobData = job?.jobData?.job
    const jobLogs = useSelector((state) => state?.jobs?.jobData?.jobLogs)
    console.log(jobLogs)
    const { usersList, loading } = useSelector((state) => state?.user)

    useEffect(() => {
        dispatch(getJobById(id))
    }, [dispatch, id])

    useEffect(() => {
        let add = null
        if (typeof jobData?.delivery_address == "object") {
            setAddress(`${jobData?.delivery_address?.address}, ${jobData?.delivery_address?.city}`)
        } else {
            setAddress(`${jobData?.delivery_address}`)
        }
        const total = jobData?.services?.reduce((sum, data) => {
            return sum + Number(data?.service_type?.price)
        }, 0)
        if (statusForm) {
            statusForm.setFieldsValue({
                status : jobData?.status
            })
        }
        if (jobStepform) {
            jobStepform.setFieldsValue({
                job_step : jobData?.job_step
            })
        }
        setTotalPrice(total)
    }, [jobData?.services])

    const handleFinish = async (values) => {
        setButtonLoading(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            const formData = new FormData()
            let data = {
                ...jobData,
                agent_id : values?.agent_id,
                type: "assign_job"
            }
            const resultAction = await dispatch(createJob(data))
            if (createJob.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || 'Job assign to agent successfully');
                setAlertType('success');
                form.resetFields();
            } else {
                setAlertMessage(resultAction?.payload || 'Error assigning job to agent');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Failed to submit job form.');
            setAlertType('error');
        } finally {
            setButtonLoading(false);
        }
    };

    const handleSearch = (value) => {
        if (value.length == 0) {
            dispatch(clearUsersList())
        }
        if (value.length < 3) return;
        dispatch(getUsersForJobAssigning({ roleType: "agent", search: value }));
    };

    const onClear = () => {
        dispatch(clearUsersList());
    }

    const handleUpdateStatus = async (values) => {
        setStatusButtonLoading(true)
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            let data = {
                ...values,
                id
            }
            const resultAction = await dispatch(updateJobStatus(data))
            if (updateJobStatus.fulfilled.match(resultAction)) {
                setStatusAlertMessage(resultAction?.payload?.message || 'Job status updated successfully');
                setStatusAlertType('success');
                form.resetFields();
            } else {
                setStatusAlertMessage(resultAction?.payload?.error || 'Error updating job status');
                setStatusAlertType('error');
            }
        } catch (error) {
            setStatusAlertMessage('Failed to update job status.');
            setStatusAlertType('error');
        } finally {
            setStatusButtonLoading(false);
        }
    }

    const handleUpdateJobStep = async (values) => {
        setjobStepBtnLoading(true)
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            let data = {
                ...values,
                id
            }
            const resultAction = await dispatch(updateJobStep(data))
            if (updateJobStep.fulfilled.match(resultAction)) {
                setJobStepAlertMessage(resultAction?.payload?.message || 'Job step updated successfully');
                setJobAlertType('success');
            } else {
                setJobStepAlertMessage(resultAction?.payload?.error || 'Error updating job step');
                setJobAlertType('error');
            }
        } catch (error) {
            setJobStepAlertMessage('Failed to update job step.');
            setJobAlertType('error');
        } finally {
            setjobStepBtnLoading(false);
        }
    }

    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Customer</h1>
            <Card
                title={
                    <span style={{ fontSize: '18px', fontWeight: 600 }}>
                        <UserOutlined style={{ marginRight: 8, color: '#CA9AE8' }} />
                        User Information
                    </span>
                }
                style={{
                    marginBottom: 24,
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    border: 'none',
                }}
            >
                <Descriptions column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }} bordered>
                    <Descriptions.Item label={<span><UserOutlined style={{ marginRight: 4 }} />Name</span>}>
                        {`${jobData?.user_id?.first_name} ${jobData?.user_id?.last_name}`}
                    </Descriptions.Item>
                    <Descriptions.Item label={<span><MailOutlined style={{ marginRight: 4 }} />Email</span>}>
                        {jobData?.user_id?.email || 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label={<span><UserOutlined style={{ marginRight: 4 }} />Gender</span>}>
                        {jobData?.user_id?.gender || 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label={<span><PhoneOutlined style={{ marginRight: 4 }} />Phone Number</span>}>
                        {jobData?.user_id?.phone || 'N/A'}
                    </Descriptions.Item>
                </Descriptions>
            </Card>
            <Card
                title={
                    <span style={{ fontSize: '18px', fontWeight: 600 }}>
                        <UserOutlined style={{ marginRight: 8, color: '#CA9AE8' }} />
                        Job Information
                    </span>
                }
                style={{
                    marginBottom: 24,
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    border: 'none',
                }}
            >
                <Descriptions column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }} bordered>
                    <Descriptions.Item label={<span><ScheduleOutlined style={{ marginRight: 4 }} />Job Date</span>}>
                        {`${new Date(jobData?.job_date).toLocaleDateString('en-CA')}`}
                    </Descriptions.Item>
                    <Descriptions.Item label={<span><MailOutlined style={{ marginRight: 4 }} />Shift</span>}>
                        {jobData?.time_slot || 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label={<span><FieldTimeOutlined style={{ marginRight: 4 }} />Job Start Time</span>}>
                        {jobData?.job_start_time ? formattedDateTime(new Date(jobData?.job_start_time)) : 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label={<span><FieldTimeOutlined style={{ marginRight: 4 }} />Job End Time</span>}>
                        {jobData?.job_end_time ? formattedDateTime(new Date(jobData?.job_end_time)) : 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label={<span><FieldTimeOutlined style={{ marginRight: 4 }} />Status</span>}>
                        {jobData?.status || 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label={<span><FieldTimeOutlined style={{ marginRight: 4 }} />Delivery Address</span>}>
                        {address || 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label={<span><ProductOutlined style={{ marginRight: 4 }} />Categorization</span>}>
                        {jobData?.categorization || 'N/A'}
                    </Descriptions.Item>
                </Descriptions>
                <Image.PreviewGroup>
                    {jobData?.images?.map((img, idx) => (
                        <Image
                        key={idx}
                        width={150}
                        src={`${process.env.REACT_APP_BASE_URL.replace('/api', '')}${img}`}
                        style={{ marginRight: 8, marginBottom: 8 }}
                        />
                    ))}
                    </Image.PreviewGroup>
            </Card>
            <Card
                title={
                    <span style={{ fontSize: '18px', fontWeight: 600 }}>
                        <ProductFilled style={{ marginRight: 8, color: '#CA9AE8' }} />
                        Products
                    </span>
                }
                style={{
                    marginBottom: 24,
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    border: 'none',
                }}
            >
                <Table
                    dataSource={jobData?.services}
                    rowKey={(item) => item.service_type}
                    columns={[
                        {
                            title: "Category",
                            dataIndex: ["category", "name"]
                        },
                        {
                            title: "Sub Category",
                            dataIndex: ["subCategory", "name"]
                        },
                        {
                            title: "Service",
                            dataIndex: ["service_type", "title"]
                        },
                        {
                            title: "Price",
                            dataIndex: ["service_type", "price"],
                            render: (v) => `$${v}`
                        },
                        {
                            title: "Quantity",
                            dataIndex: ["quantity"]
                        }
                    ]}
                />
                <p>Total Price : {jobData?.cost}</p>
            </Card>
            <Card title={"Status Change"} style={{ marginBottom: 16 }}>
                {statusAlertMessage && (
                    <Alert
                        message={statusAlertMessage}
                        type={statusalertType}
                        showIcon
                        icon={statusalertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setStatusAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    onFinish={handleUpdateStatus}
                    form={statusForm}
                >
                    <Form.Item
                        label="Status"
                        name="status"
                    >
                        <Select
                            options={[
                                { value: 'pending', label: 'Pending' },
                                { value: 'confirmed', label: 'Confirmed' },
                                { value: 'ontheway', label: 'On The Way' },
                                { value: 'started', label: 'Started' },
                                { value: 'completed', label: 'Completed' },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Button
                            type="primary"
                            htmlType="submit"
                            loading={statusButtonLoading}
                            size="large"
                            block
                            style={{
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: '8px',
                            }}
                            >
                                Save Changes
                            </Button>
                            <Button onClick={(e) => navigate(-1)}>Back</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
            <Card title={`Assign to Agent ${(jobData?.agent_id?.first_name) ?? ""} ${(jobData?.agent_id?.last_name) ?? ""}`} style={{ marginBottom: 16 }}>
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    onFinish={handleFinish}
                    form={form}
                >
                    <Form.Item
                        label="Agents"
                        name="agent_id"
                    >
                        {/* <Select
                            options={[
                                { value: 'Block', label: 'Block' },
                                { value: 'UnBlock', label: 'UnBlock' },
                            ]}
                        /> */}
                        <Select
                            showSearch
                            allowClear
                            placeholder="Type at least 3 characters to search"
                            filterOption={false} // disable local filtering
                            onSearch={handleSearch} // called when user types
                            notFoundContent={loading ? <Spin size="small" /> : null}
                            onClear={onClear}
                            options={usersList?.data?.map((data) => ({
                                value: data._id,
                                label: `${data.first_name} ${data?.last_name}`,
                            }))}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Button
                            type="primary"
                            htmlType="submit"
                            loading={buttonLoading}
                            size="large"
                            block
                            style={{
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: '8px',
                            }}
                            >
                                Save Changes
                            </Button>
                            <Button onClick={(e) => navigate(-1)}>Back</Button>
                        </Space>
                    </Form.Item>
                </Form>
                {jobLogs?.length > 0 ? (
                    jobLogs.map((data, index) => (
                        <Descriptions
                            key={index}
                            column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                            bordered
                            >
                            {/* <Descriptions.Item label="Job Log">
                                {data.description}
                            </Descriptions.Item> */}
                            <Descriptions.Item label="Job Log">
                                <div>{data.description}</div>
                                <div style={{ color: 'gray', marginTop: 4 }}>
                                {new Date(data.createdAt).toISOString().slice(0, 10)}
                                </div>
                            </Descriptions.Item>
                        </Descriptions>
                    ))
                ) : null}

            </Card>
            {jobData?.complex_services?.length > 0 ? (
                <Card title={`Job Step`} style={{ marginBottom: 16 }}>
                    {jobStepAlertMessage && (
                        <Alert
                            message={jobStepAlertMessage}
                            type={alertType}
                            showIcon
                            icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                            closable
                            onClose={() => setJobStepAlertMessage('')}
                            style={{
                                marginBottom: 24,
                                borderRadius: '8px',
                            }}
                        />
                    )}
                    <b>Estimations</b><br/><br/>
                    {jobData?.complex_services?.map((data) => {
                        return (
                            <>
                                <Table columns={[
                                        {
                                            title: "Description",
                                            dataIndex: "name",
                                            key: "name",
                                        },
                                        {
                                            title: "Cost",
                                            dataIndex: "cost",
                                            key: "cost",
                                        },
                                ]}
                                dataSource={
                                    data
                                        ? [
                                            {
                                            key: "1",
                                            name: data.name,
                                            cost: data.cost,
                                            },
                                        ]
                                        : []
                                } pagination={false}>
                                </Table>
                            </>
                        )
                    })}
                    <br />
                    <Form
                        layout="vertical"
                        onFinish={handleUpdateJobStep}
                        form={jobStepform}
                    >
                        <Form.Item
                                label="Job Step"
                                name="job_step"
                            >
                            <Select
                                options={[
                                    { value: 'estimation send to customer', label: 'Estimation send to customer' },
                                    { value: 'estimation approved', label: 'Estimation approved' },
                                    { value: 'service estimation', label: 'Service Estimation' },
                                    { value: 'started', label: 'Started' },
                                    { value: 'completed', label: 'Completed' },
                                ]}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Space>
                                <Button
                                type="primary"
                                htmlType="submit"
                                loading={jobStepBtnLoading}
                                size="large"
                                block
                                style={{
                                    height: '48px',
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    borderRadius: '8px',
                                }}
                                >
                                    Save Changes
                                </Button>
                                <Button onClick={(e) => navigate(-1)}>Back</Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </Card>
            ) : ""}
        </div>
    );
};

export default ViewJob;